import React, { createContext, useContext, useState, useEffect } from 'react';

const LanguageContext = createContext();

export const useLanguage = () => {
  const context = useContext(LanguageContext);
  if (!context) {
    throw new Error('useLanguage must be used within a LanguageProvider');
  }
  return context;
};

const translations = {
  en: {
    nav: {
      services: 'Services',
      industries: 'Industries',
      insights: 'Insights',
      careers: 'Careers',
      about: 'About',
      contact: 'Contact'
    },
    hero: {
      title: 'Navigate Your Next with AuVSys',
      subtitle: 'Transform your enterprise with cutting-edge AI, cloud solutions, and digital innovation. Join 500+ global leaders who trust AuVSys for their technology transformation.',
      exploreServices: 'Explore Services',
      watchStory: 'Watch Demo'
    },
    common: {
      learnMore: 'Learn More',
      readMore: 'Read More',
      viewDetails: 'View Details',
      apply: 'Apply Now',
      search: 'Search',
      filters: 'Filters',
      clearAll: 'Clear All',
      loading: 'Loading...',
      error: 'Error occurred',
      close: 'Close',
      open: 'Open',
      menu: 'Menu'
    },
    accessibility: {
      skipToContent: 'Skip to main content',
      mainNavigation: 'Main navigation',
      searchButton: 'Search',
      themeToggle: 'Toggle theme',
      languageSelector: 'Select language',
      mobileMenu: 'Mobile menu'
    }
  },
  es: {
    nav: {
      services: 'Servicios',
      industries: 'Industrias',
      insights: 'Perspectivas',
      careers: 'Carreras',
      about: 'Acerca de',
      contact: 'Contacto'
    },
    hero: {
      title: 'Navega tu Próximo con AuVSys',
      subtitle: 'Transforma tu empresa con IA de vanguardia, soluciones en la nube e innovación digital. Únete a más de 500 líderes globales que confían en AuVSys para su transformación tecnológica.',
      exploreServices: 'Explorar Servicios',
      watchStory: 'Ver Demo'
    },
    common: {
      learnMore: 'Saber Más',
      readMore: 'Leer Más',
      viewDetails: 'Ver Detalles',
      apply: 'Aplicar Ahora',
      search: 'Buscar',
      filters: 'Filtros',
      clearAll: 'Limpiar Todo',
      loading: 'Cargando...',
      error: 'Ocurrió un error',
      close: 'Cerrar',
      open: 'Abrir',
      menu: 'Menú'
    },
    accessibility: {
      skipToContent: 'Saltar al contenido principal',
      mainNavigation: 'Navegación principal',
      searchButton: 'Buscar',
      themeToggle: 'Cambiar tema',
      languageSelector: 'Seleccionar idioma',
      mobileMenu: 'Menú móvil'
    }
  }
};

export const LanguageProvider = ({ children }) => {
  const [language, setLanguage] = useState(() => {
    const saved = localStorage.getItem('language');
    return saved || 'en';
  });

  useEffect(() => {
    localStorage.setItem('language', language);
    document.documentElement.lang = language;
  }, [language]);

  const t = (key) => {
    const keys = key.split('.');
    let value = translations[language];
    for (const k of keys) {
      value = value?.[k];
    }
    return value || key;
  };

  return (
    <LanguageContext.Provider value={{ language, setLanguage, t }}>
      {children}
    </LanguageContext.Provider>
  );
};